'use strict';

angular.module('myConsultApp')
  .factory('ActivityTypeService', function ($resource, ENV, Session) {
    var activityTypeService = {};

    activityTypeService.getActivityTypes = function(search, status, order, limit, pageno) {
        var activityTypes = $resource(ENV.apiEndpoint + '/1.0/activity-types/', {}, { get: { headers: { 'Authorization': 'Bearer '+Session.accessToken } } });

        var searchData = {
          search: search,
          status: status,
          order: order,
          page_size: limit,
          page: pageno,
        }
        return activityTypes.get(searchData).$promise.then(function(response) {
            return response;
        });
    };
    
    activityTypeService.getPage = function (url) {
        var activityTypes = $resource(url, {}, { get: { headers: { 'Authorization': 'Bearer '+Session.accessToken } } });

        return activityTypes.get({}).$promise.then(function(response) {
            return response;
        });
    };

    activityTypeService.getClassifications = function() {
        var classifications = $resource(ENV.apiEndpoint + '/1.0/activity-types-classification/', {}, { get: { headers: { 'Authorization': 'Bearer '+Session.accessToken } } });

        return classifications.get().$promise.then(function(response) {
            return response;
        });
    };

    activityTypeService.getFrequencyPeriods = function() {
        var frequencyPeriods = $resource(ENV.apiEndpoint + '/1.0/activity-types-frequency-period/', {}, { get: { headers: { 'Authorization': 'Bearer '+Session.accessToken } } });
        
        return frequencyPeriods.get().$promise.then(function(response) {
            return response;
        });
    };

    activityTypeService.createActivityType = function(activityType) {
        var newActivityType = $resource(ENV.apiEndpoint + '/1.0/activity-types/', {}, {
            save:{
                method: 'POST',
                headers: { 'Authorization': 'Bearer ' + Session.accessToken }
            }
        });

        return newActivityType.save(activityType).then(function(response) {
            return response;
        });
    };

    activityTypeService.updateActivityType = function(id, activityType) {
        var updatedActivityType = $resource(ENV.apiEndpoint + '/1.0/activity-types/:id/', { id: id }, {
            update: {
                method: 'PUT',
                headers: { 'Authorization': 'Bearer ' + Session.accessToken }
            }
        });

        return updatedActivityType.update(activityType).then(function(response) {
            return response;
        });
    };

    activityTypeService.getActivityType = function(id) {
        var activityType = $resource(ENV.apiEndpoint + '/1.0/activity-types/:id/', { id: id }, {
            get: {
                headers: { 'Authorization': 'Bearer ' + Session.accessToken }
            }
        });

        return activityType.get().$promise.then(function(response) {
            return response;
        });
    };

    return activityTypeService;
});
